import { UnicodeEntity } from '@mews/enums';
import AgeCategoryName from './connected/AgeCategoryName';
import ProductName from './ProductName';

interface Props {
    productId: string | null;
    ageCategoryId: string | null;
    totalNumberOfProducts?: number;
}

const ProductOrderLabel = ({ productId, ageCategoryId, totalNumberOfProducts = 1 }: Props) => {
    const totalNumberLabel = (
        <>
            {totalNumberOfProducts}
            {UnicodeEntity.NoBreakSpace}
            {UnicodeEntity.MultiplicationSign}
            {UnicodeEntity.NoBreakSpace}
        </>
    );
    return (
        <div>
            {totalNumberOfProducts > 1 ? totalNumberLabel : null}
            {productId !== null && <ProductName productId={productId} />}
            {ageCategoryId !== null && (
                <span>
                    {UnicodeEntity.NoBreakSpace}
                    {UnicodeEntity.LeftParenthesis}
                    <AgeCategoryName id={ageCategoryId} />
                    {UnicodeEntity.RightParenthesis}
                </span>
            )}
        </div>
    );
};

export default ProductOrderLabel;
